import { trackAnalyticsEvent } from '@eb/site-analytics';

export const trackShareAction = (label: string) =>
    trackAnalyticsEvent({
        action: 'Share',
        category: 'listing',
        label,
    });
